import AdminPanel from "../../../vendor/arbory/arbory/resources/assets/js/admin";

AdminPanel.initialize();
